import { Box, Flex, Text, useMantineTheme } from "@mantine/core";
import { ClientCardBg } from "src/utils/constants";

interface IOrgProps {
  primaryColor: string;
  secondaryColor: string;
}

interface ISkeletonProps {
  width: string;
  color: string;
}

const CustomSkeleton = ({ width, color }: ISkeletonProps) => {
  return (
    <Flex w={width} h={20} my={10} bg={color} style={{ borderRadius: "5px" }} />
  );
};

const BrandingPreview = ({ primaryColor, secondaryColor }: IOrgProps) => {
  const theme = useMantineTheme();
  return (
    <Flex
      direction={"column"}
      align={"center"}
      justify={"center"}
      style={{
        //borderTop: `1px solid #ddd`,
        backgroundColor: theme.colors.secondary[9],
        borderRadius: 4,
      }}
      p={30}
      mt={30}
    >
      <Text fw={600} size={20}>
        App Theme Preview
      </Text>
      <Flex m={10}>
        <Box
          w={250}
          //h={425}
          p={10}
          bg={secondaryColor}
          style={{ borderRadius: "5px", overflowY: "auto" }}
        >
          <Flex justify={"space-between"} mb={5}>
            <CustomSkeleton width="20%" color={primaryColor} />
            <CustomSkeleton width="40%" color={primaryColor} />
          </Flex>
          <Flex my={5} style={{ borderRadius: "5px" }}>
            <CustomSkeleton width="100%" color={primaryColor} />
          </Flex>
          <Flex
            direction={"column"}
            bg={ClientCardBg}
            style={{ borderRadius: "5px" }}
            my={10}
            p={10}
          >
            <CustomSkeleton width="90%" color={primaryColor} />
            <CustomSkeleton width="70%" color={primaryColor} />
            <CustomSkeleton width="70%" color={primaryColor} />
            <CustomSkeleton width="70%" color={primaryColor} />
          </Flex>
          <Flex
            direction={"column"}
            bg={ClientCardBg}
            style={{ borderRadius: "5px" }}
            mt={5}
            p={10}
          >
            <CustomSkeleton width="90%" color={primaryColor} />
            <CustomSkeleton width="70%" color={primaryColor} />
            <CustomSkeleton width="70%" color={primaryColor} />
            <CustomSkeleton width="70%" color={primaryColor} />
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
};

export default BrandingPreview;
